import React from 'react'
import SvgWrapper from '../SvgWrapper'
import { ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const ManagerTasks: React.FC<IconProps> = ({
  color = 'currentColor',
  size = ICON_SIZE.medium,
  viewBox = ICON_VIEWBOX.medium,
  isFilled,
  fillOpacity,
}) => {
  const path = isFilled ? (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.091 21h15.817C21.447 21 22 19.797 22 18.994V9.12c0-1.47-1.25-2.006-2.091-2.006h-3.25l-.881-2.653a2.117 2.117 0 0 0-.78-1.06c-.369-.257-.8-.401-1.25-.401h-3.496c-.45 0-.892.134-1.25.401a2.117 2.117 0 0 0-.78 1.06l-.881 2.653H4.09C2.554 7.114 2 8.318 2 9.12v9.874C2 20.465 3.25 21 4.091 21zM15.03 7.114H8.971l.717-2.16a.579.579 0 0 1 .216-.298.613.613 0 0 1 .348-.113h3.496c.123 0 .246.041.348.113a.579.579 0 0 1 .216.298l.717 2.16zm-4.951 9.69c.154.05.307.082.471.082l-.01.02h.092c.195-.01.38-.061.554-.154.154-.082.287-.195.4-.319l4.008-3.857a.769.769 0 0 0 .02-1.09.762.762 0 0 0-1.086-.02l-3.937 3.836-1.055-1.492a.757.757 0 0 0-1.067-.185.762.762 0 0 0-.184 1.07l1.2 1.697c.015.015.03.033.045.051a.92.92 0 0 0 .047.052c.133.133.307.236.502.308z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  ) : (
    <path
      d="M19.898 21H4.091C3.251 21 2 20.465 2 18.994V9.12c0-.802.554-2.006 2.091-2.006h3.25l.881-2.653c.144-.432.41-.792.78-1.06.358-.267.8-.401 1.25-.401h3.496c.45 0 .881.144 1.25.401.37.268.636.628.78 1.06l.881 2.653h3.25c.84 0 2.091.535 2.091 2.006v9.874c0 .803-.554 2.006-2.091 2.006h-.01zM7.894 8.657H4.091c-.154 0-.533 0-.553.473v9.864c0 .113 0 .453.553.463h15.807c.165 0 .534 0 .554-.473V9.12c0-.298-.184-.453-.554-.463H7.894zm1.067-1.543h6.068l-.717-2.16a.579.579 0 0 0-.216-.298.613.613 0 0 0-.348-.113h-3.496a.613.613 0 0 0-.348.113.579.579 0 0 0-.216.298l-.717 2.16h-.01zm1.588 9.772c-.164 0-.317-.031-.471-.083a1.382 1.382 0 0 1-.502-.308c-.031-.031-.062-.072-.093-.103l-1.199-1.697a.763.763 0 0 1 .184-1.07.757.757 0 0 1 1.067.185l1.056 1.492 3.936-3.837a.763.763 0 0 1 1.087.02.769.769 0 0 1-.021 1.091l-4.008 3.857a1.518 1.518 0 0 1-.4.319 1.314 1.314 0 0 1-.553.154h-.093l.01-.02z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  )

  return (
    <SvgWrapper viewBox={viewBox} size={size} fill="none">
      {path}
    </SvgWrapper>
  )
}

export default ManagerTasks
